import KeywordHighlight from './KeywordHighlight'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class TextResponseMain extends Component {
  static propTypes = {
    response: PropTypes.object.isRequired,
    searchHighlights: PropTypes.array
  }

  static defaultProps = {
    searchHighlights: []
  }

  render() {
    const { response, searchHighlights } = this.props
    const commentTxt = response.commentTxt || ''
    const tokens = searchHighlights.reduce((memo, highlight) => {
      return memo.concat(highlight.tokens)
    }, [])

    return <KeywordHighlight text={commentTxt.trim()} tokens={tokens} />
  }
}



// WEBPACK FOOTER //
// ../src/components/TextResponseMain.js